export enum GzChatCardState {
  SUCCESS = 'is-success',
  LOADING = 'is-loading',
  ERROR = 'is-error',
}

export enum GzChatCardEvents {
  FEEDBACK = 'chatCardFeedback',
  REFRESH = 'chatCardRefresh',
  REGENERATE = 'chatCardRegenerate',
}
